import React from 'react';
import {FormattedDate, FormattedTime} from "react-intl";
import {useSelector} from "react-redux";

export function TimezoneTime(props) {
    const timezone = useSelector<any, string>(state => state.settings.timezone);
    return (
        <FormattedTime {...props} timeZone={timezone}></FormattedTime>
    );
}

export function TimezoneDate(props){
    const timezone = useSelector<any, string>(state => state.settings.timezone);
    return (
        <FormattedDate {...props} timeZone={timezone}></FormattedDate>
    );
}
